export default __webpack_public_path__ + "static/media/close-chip.3604bf06.svg";